import { FixtureSpriteColors } from "../fixture/FixtureSpriteColors";
import { FixtureTypeNames } from "../fixture/FixtureTypeNames";
import BasicSprite from "./BasicSprite";
import NamedSpriteSpritesheet from "./NamedSpriteSpritesheet";
import Sprite from "./Sprite";

export default class StaticFixtureSpritesheet extends NamedSpriteSpritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     */
    constructor(fileName, spriteSize) {
        super(fileName, spriteSize);

        // Tell the superclass to start loading the image.
        this.loadImage();
    }

    /**
     * @param {string} fixtureTypeName 
     * @param {string} colorName 
     * @returns {string}
     */
    static getSpriteName(fixtureTypeName, colorName) {
        return fixtureTypeName + '_' + colorName;
    }

    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {

        let row = 0;

        // Iterate over the sprite name configs
        for (let typeName of Object.values(FixtureTypeNames)) {
            this.parseRow(row, typeName);
            row++;
        }

        /////////////////////////////////////
        // Mark the spritesheet as loaded.
        /////////////////////////////////////

        this.loaded = true;
    }

    /**
     * @private
     * @param {number} row 
     * @param {string} fixtureTypeName
     */
    parseRow(row, fixtureTypeName) {
        const step = this.spriteSize + 1; // There is a 1px buffer between the sprites, only on the bottom and right edges.

        const y = row * step;
        let x = 0;

        // Iterate over the fixture color configs
        for (let colorName of Object.values(FixtureSpriteColors)) {
            const name = StaticFixtureSpritesheet.getSpriteName(fixtureTypeName, colorName);
            this.spriteMap[name] = new BasicSprite(this, x, y);
            x += step;
        }    
    }

    /**
     * @param {string} fixtureTypeName 
     * @param {string} colorName 
     * @returns {Sprite}
     */
    getFixtureSprite(fixtureTypeName, colorName) {
        return this.getSprite(StaticFixtureSpritesheet.getSpriteName(fixtureTypeName, colorName));
    }

}